import { useEffect } from 'react';
import { useSnapshot } from 'valtio';

import { ProjectType } from '@cartwhl/common/types';
import Modal from '@cartwhl/ui/molecules/Modal';

import {
  animationGenerationStore,
  animationPlayerStore,
  projectStore,
} from 'stores';
import { pollExportStatus } from 'stores/animationGenerationStore';
import { pollProjectExportStatus } from 'stores/projectStore';

import MotionDownload from './MotionDownload';
import PoseDownload from './PoseDownload';

export default function DownloadModal({ close }: { close: () => void }) {
  const { animationPaths } = useSnapshot(animationGenerationStore.state);
  const { currentProject } = useSnapshot(projectStore.state);
  const isPoseProject = currentProject.data?.type === ProjectType.POSE;

  useEffect(() => {
    if (isPoseProject) {
      pollProjectExportStatus(false).catch((error) => {
        console.error('Error polling project export status:', error);
      });
    } else {
      pollExportStatus(false).catch((error) => {
        console.error('Error polling export status:', error);
      });
    }
  }, []);

  // when the component unmounts lets call removeAnimationPlayerStoreByID
  useEffect(() => {
    return () => {
      animationPlayerStore.resetVideoRecording();
      animationPlayerStore.removeAnimationPlayerStoreByID(animationPaths[0]);
    };
  }, [animationPaths]);

  const handleOpenChange = async (open: boolean) => {
    if (open && isPoseProject) {
      await projectStore.loadCurrentProject(currentProject.data?.projectID);
    }

    if (!open) {
      close();
      animationPlayerStore.resetVideoRecording();
    }
  };

  return (
    <Modal
      open={true}
      onOpenChange={handleOpenChange}
      maxWidth={800}
      fullscreenOnMobile
      verticalBleed
    >
      <div className="mb-3 flex flex-none flex-col gap-4 sm:flex-row sm:items-center sm:justify-between lg:gap-4">
        <h2 className="font-display mt-6 text-[20px]/[20px] font-medium sm:w-[148px] lg:w-[180px]">
          Download
        </h2>
      </div>
      {isPoseProject ? (
        <PoseDownload handleOpenChange={handleOpenChange} />
      ) : (
        <MotionDownload handleOpenChange={handleOpenChange} />
      )}
    </Modal>
  );
}
